"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var pp_react_1 = require("@paypalcorp/pp-react");
var pp_react_radio_1 = require("@paypalcorp/pp-react-radio");
var commonUtils_1 = require("../../../common/utils/commonUtils");
var constants_1 = require("../../../constants");
var commonweb_utils_1 = require("commonweb-utils");
var phones_1 = require("../../../actions/phones");
var ajax_util_1 = require("../../../utils/ajax/ajax.util");
var ErrorContentMapper_1 = require("../../../utils/errorcodes/ErrorContentMapper");
var phone_1 = require("../../../utils/container/phone");
var utils_1 = require("../../../common/utils/phones/utils");
var triggerOperationResult_1 = require("../../../utils/fpti/triggerOperationResult");
var page = require("page");
var ChangePrimaryPhone = /** @class */ (function (_super) {
    tslib_1.__extends(ChangePrimaryPhone, _super);
    function ChangePrimaryPhone(props) {
        var _this = _super.call(this, props) || this;
        _this.chooseNewPrimary = function (event) {
            var newPhone = _this.props.phones.find(function (phone) { return phone.maskedSubscriberNumber == event.target.value; });
            _this.setState({
                newPrimaryPhoneNumber: event.target.value,
                errorMessage: "",
                newPrimaryPhoneId: newPhone["id"],
                currentCallPref: newPhone.callPref,
                currentTextPref: newPhone.textPref,
                newCallPref: newPhone.callPref,
                newTextPref: newPhone.textPref,
            });
        };
        var currentPrimaryPhoneId = commonweb_utils_1.objectUtils.safeGet(_this.props, "route.enter.params.id") || "", currentPrimaryPhoneType = "", currentPrimaryPhoneNumber = "", phonesList = _this.props.phones, enableTcpa = phonesList &&
            phonesList.length > 0 &&
            phonesList[0].accountCountryCode === "US", currentCallPref = true, currentTextPref = true, currentPrimaryPhone = commonUtils_1.findObjectInListById(phonesList, currentPrimaryPhoneId);
        if (currentPrimaryPhone) {
            currentPrimaryPhoneNumber =
                currentPrimaryPhone.maskedSubscriberNumber;
            currentPrimaryPhoneType = currentPrimaryPhone.type;
            currentPrimaryPhoneId = currentPrimaryPhone.id;
            currentCallPref = currentPrimaryPhone.callPref;
            currentTextPref = currentPrimaryPhone.textPref;
            enableTcpa = phone_1.isTcpaEnabled(currentPrimaryPhone, _this.props);
        }
        _this.state = {
            id: commonweb_utils_1.objectUtils.safeGet(_this.props, "route.enter.params.id") || "",
            currentPrimaryPhoneNumber: currentPrimaryPhoneNumber,
            currentPrimaryPhoneType: currentPrimaryPhoneType,
            currentPrimaryPhoneId: currentPrimaryPhoneId,
            newPrimaryPhoneId: currentPrimaryPhoneId,
            newPrimaryPhoneNumber: currentPrimaryPhoneNumber,
            errorMessage: "",
            showSpinner: false,
            currentCallPref: currentCallPref,
            currentTextPref: currentTextPref,
            newCallPref: currentCallPref,
            newTextPref: currentTextPref,
            enableTcpa: enableTcpa,
        };
        return _this;
    }
    ChangePrimaryPhone.prototype.componentDidMount = function () {
        window.scroll({
            top: 0,
            behavior: "smooth",
        });
    };
    ChangePrimaryPhone.prototype.handleAdd = function (event) {
        event.preventDefault();
        if (!this.state.showSpinner) {
            this.props.changePrimaryType(this.state.currentPrimaryPhoneType);
            page(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.ADD);
        }
    };
    ChangePrimaryPhone.prototype.handleSetPrimary = function (event) {
        var _this = this;
        event.preventDefault();
        var tcpaChanged = phone_1.isTcpaChanged(this.state.currentCallPref, this.state.currentTextPref, this.state.newCallPref, this.state.newTextPref);
        // No change in number, Change in TCPAPref for existing primary number only
        if (this.state.currentPrimaryPhoneId === this.state.newPrimaryPhoneId &&
            this.state.enableTcpa &&
            tcpaChanged) {
            var formData = {};
            formData["id"] = this.state.newPrimaryPhoneId;
            formData["callPref"] = this.state.newCallPref;
            formData["textPref"] = this.state.newTextPref;
            formData["isTcpaEnabled"] = this.state.enableTcpa;
            formData["isSCAEnabled"] = utils_1.isSCAEnabled(this.props.features);
            this.setState({ errorMessage: "", showSpinner: true });
            ajax_util_1.default.post$(this.props.dispatch, this.props._csrf, "" + constants_1.default.ROUTES.API.PHONES.SET_TCPA, formData, { component: { name: constants_1.default.VIEWS.PHONES.CHANGE_PRIMARY } })
                .then(function (phoneInfo) {
                var toastIntent = constants_1.default.VIEWS.PHONES.TOAST_INTENTS.SET_PRIMARY;
                if (phoneInfo && phoneInfo.phones) {
                    phoneInfo.phones = commonUtils_1.modifyObjectWithFactorById(phoneInfo.phones, _this.state.newPrimaryPhoneId, toastIntent, true);
                }
                _this.props.dispatchPrimaryPhoneTcpa(phoneInfo);
                _this.props.performedAction(toastIntent);
                _this.setState({ showSpinner: false });
                page.redirect(constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MANAGE);
            })
                .catch(function (error) {
                var errorMessage = ErrorContentMapper_1.getPhoneErrorContent(error, _this.props.content);
                _this.setState({
                    showSpinner: false,
                    errorMessage: errorMessage,
                });
                triggerOperationResult_1.triggerOperationResult(_this.props.phoneFpti.changePrimary, constants_1.default.FPTI.FAILURE, errorMessage);
                window.scroll({
                    top: 0,
                    behavior: "smooth",
                });
                return;
            });
        }
        else if (this.state.currentPrimaryPhoneId !== this.state.newPrimaryPhoneId) {
            // Set new number as Primary.
            var callPref = this.state.newCallPref ? "-T" : "-F", textPref = this.state.newTextPref ? "-T" : "-F", url = constants_1.default.BASE_URI + "/flow" + constants_1.default.ROUTES.PHONES.MAKE_PRIMARY;
            url = url.replace(":id", this.state.newPrimaryPhoneId + callPref + textPref);
            page(url);
        }
        else {
            // No Update
            var errorMessage = this.props.content.phones.error.alreadyPrimary;
            this.setState({ errorMessage: errorMessage });
            triggerOperationResult_1.triggerOperationResult(this.props.phoneFpti.changePrimary, constants_1.default.FPTI.FAILURE, errorMessage);
            window.scroll({
                top: 0,
                behavior: "smooth",
            });
        }
    };
    ChangePrimaryPhone.prototype.tcpaPrefHandler = function (event) {
        if (!this.state.showSpinner) {
            this.setState({ errorMessage: "" });
            if (event.target.name && event.target.name.includes("smsTcpa_")) {
                this.setState({ newTextPref: !this.state.newTextPref });
            }
            if (event.target.name && event.target.name.includes("callTcpa_")) {
                this.setState({ newCallPref: !this.state.newCallPref });
            }
        }
        else {
            event.preventDefault();
        }
    };
    ChangePrimaryPhone.prototype.getLabel = function (phoneList, phoneContent) {
        return phoneList &&
            phoneList.find(function (phone) { return phone.primary; })["type"] ==
                constants_1.default.PHONE_TYPE.WORK
            ? phoneContent.currentprimary.work.helptext
            : phoneList.find(function (phone) { return phone.primary; })["type"] ==
                constants_1.default.PHONE_TYPE.MOBILE
                ? phoneContent.currentprimary.mobile.helptext
                : phoneContent.currentprimary.home.helptext;
    };
    ChangePrimaryPhone.prototype.getHelperText = function (phoneList, phone, phoneContent) {
        var _this = this;
        var callTcpaTrackingValue = "callTcpa_" + (this.state.newCallPref ? "OFF" : "ON"), smsTcpaTrackingValue = "smsTcpa_" + (this.state.newTextPref ? "OFF" : "ON");
        return phone.region == "US" &&
            phone.maskedSubscriberNumber == this.state.newPrimaryPhoneNumber ? (React.createElement("div", null,
            React.createElement(pp_react_1.Text, { size: "md", className: "alignLeft changePrimary-tcpa_desc" }, phoneContent.tcpa.description),
            React.createElement(pp_react_1.CheckboxGroup, { label: "", className: "changePrimary-tcpa_pref" },
                React.createElement(pp_react_1.Checkbox, { id: callTcpaTrackingValue, name: callTcpaTrackingValue, helperText: this.props.content.phones.tcpa.callsPreference
                        .subtitle, label: React.createElement(React.Fragment, null, phoneContent.tcpa.callsPreference.title), onChange: function (event) { return _this.tcpaPrefHandler(event); }, checked: this.state.newCallPref }),
                React.createElement(pp_react_1.Divider, { secondary: true, className: "divider-symmetrical" }),
                React.createElement(pp_react_1.Checkbox, { id: smsTcpaTrackingValue, name: smsTcpaTrackingValue, helperText: this.props.content.phones.tcpa.textPreference
                        .subtitle, label: React.createElement(React.Fragment, null, phoneContent.tcpa.textPreference.title), onChange: function (event) { return _this.tcpaPrefHandler(event); }, checked: this.state.newTextPref })),
            phone_1.isLastElement(phoneList, phone) ? null : (React.createElement(pp_react_1.Divider, { className: "changePrimary-divider" })))) : phone_1.isLastElement(phoneList, phone) ? null : (React.createElement(pp_react_1.Divider, { className: "changePrimary-divider" }));
    };
    ChangePrimaryPhone.prototype.hideDoneButton = function (phoneList) {
        var hideDoneButton = false;
        if (phoneList && phoneList.length == 1 && phoneList[0].region != "US") {
            hideDoneButton = true;
        }
        return hideDoneButton;
    };
    ChangePrimaryPhone.prototype.render = function () {
        var _this = this;
        var phoneContent = this.props.content.phones, commonContent = this.props.content.common, phoneAll = this.props.phones, phoneObj = [], finalPhonesObj = [], form;
        for (var phone in phoneAll) {
            if (!(phone === "sys") && !(phone === "typeOfAction")) {
                if (phoneAll.hasOwnProperty(phone)) {
                    phoneObj.push(phoneAll[phone]);
                }
            }
        }
        for (var key in phoneObj) {
            if (this.state.currentPrimaryPhoneType === phoneObj[key].type &&
                (phoneObj[key].primary || phone_1.canBeSetAsPrimary(phoneObj[key]))) {
                finalPhonesObj.push(phoneObj[key]);
            }
        }
        form = (React.createElement("form", null,
            this.state.errorMessage ? (React.createElement(pp_react_1.Alert, { type: "error", className: "alignLeft nameAlert" }, this.state.errorMessage)) : null,
            React.createElement(pp_react_1.Text, { size: "xl3", className: "alignLeft changePrimary-header" }, phoneContent.changeprimary.header),
            finalPhonesObj.length < 2 ? (React.createElement(pp_react_1.Alert, { type: "info", className: "alignLeft" }, phoneContent.changeprimary.addnew.alert.message)) : (React.createElement(pp_react_1.Text, { size: "sm", className: "alignLeft changePrimary-subheader" }, phoneContent.changeprimary.description)),
            React.createElement(pp_react_1.Container, { fluid: true, className: "changePrimary-number alignLeft" },
                React.createElement(pp_react_1.Link, { className: "alignLeft", href: "/", onClick: function (e) { return _this.handleAdd(e); }, "data-name": this.props.phoneFpti.changePrimaryAdd },
                    React.createElement(pp_react_1.Icon, { name: "add", size: "sm" }),
                    phoneContent.manageAdd.link)),
            React.createElement(pp_react_1.Divider, { className: "changePrimary-divider" }),
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: finalPhonesObj.length > 1
                        ? "changePrimary_radio"
                        : "changePrimary_radioHidden" },
                    React.createElement(pp_react_1.Container, { fluid: true, className: "alignLeft" }, finalPhonesObj && finalPhonesObj.length > 0 ? (React.createElement(pp_react_radio_1.RadioButton, { className: this.state.showSpinner
                            ? "changePrimary_clickDisabled"
                            : null, onChange: this.chooseNewPrimary, label: this.getLabel(finalPhonesObj, phoneContent), name: "phoneList", value: this.state.newPrimaryPhoneNumber, options: finalPhonesObj.map(function (phone) { return ({
                            label: phone.maskedSubscriberNumber,
                            value: phone.maskedSubscriberNumber,
                            helperText: _this.getHelperText(finalPhonesObj, phone, phoneContent),
                        }); }) })) : null))),
            finalPhonesObj && finalPhonesObj.length > 0 ? (React.createElement(pp_react_1.Divider, { className: "changePrimary_bottom_divider" })) : null,
            React.createElement(pp_react_1.Container, { fluid: true, className: "alignLeft" }, this.hideDoneButton(finalPhonesObj) ? null : (React.createElement(pp_react_1.Button, { type: "submit", className: "changePrimary-btn_done", name: this.props.phoneFpti.changePrimaryDone, disabled: this.state.showSpinner, onClick: function (e) { return _this.handleSetPrimary(e); } }, this.state.showSpinner ? (React.createElement(pp_react_1.LoadingSpinner, { className: "loading-spinner", screenReaderText: commonContent.loading, inverse: true })) : (React.createElement(pp_react_1.Text, { size: "md", className: "ok-button" }, commonContent.done)))))));
        return React.createElement("div", { className: "generic-container" }, form);
    };
    return ChangePrimaryPhone;
}(React.Component));
var mapStateToProps = function (_a) {
    var _csrf = _a._csrf, ui = _a.ui, content = _a.content, route = _a.route, features = _a.features, account = _a.account, fpti = _a.fpti;
    var phones = commonweb_utils_1.objectUtils.safeGet(account, "phones.phones") || {}, typeOfAction = commonweb_utils_1.objectUtils.safeGet(account, "phones.typeOfAction") || {}, phoneFpti = fpti.phones;
    phones = utils_1.changeNumberFormatForNonSCARegions(phones, utils_1.isSCAEnabled(features));
    return {
        _csrf: _csrf,
        ui: ui,
        route: route,
        content: content,
        phones: phones,
        typeOfAction: typeOfAction,
        phoneFpti: phoneFpti,
        features: features,
    };
};
function mapDispatchToProps(dispatch) {
    return {
        performedAction: function (typeOfAction) { return dispatch(phones_1.removeToast(typeOfAction)); },
        changePrimaryType: function (changePrimaryPhoneType) {
            return dispatch(phones_1.changePrimaryType(changePrimaryPhoneType));
        },
        dispatchPrimaryPhoneTcpa: function (phones) { return dispatch(phones_1.changePhone(phones)); },
        dispatch: dispatch,
    };
}
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(ChangePrimaryPhone);
